import BreadcrumbTwo from "../../../components/Breadcrumbs/BreadcrumbTwo";
import ProductCategoryTable from "../../../components/Catalog/categories/ProductCategoryTable";
import DefaultLayout from "../../../layout/DefaultLayout";

const ItemCategories = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <ProductCategoryTable />
    </DefaultLayout>
  );
};

export default ItemCategories;
